import { useMissionsUrl } from '@/features/missions/context/MissionsUrlProvider'
import { Button } from '@/ui-kit'
import { Trans } from '@lingui/react/macro'
import { MicOff } from 'lucide-react'
import { useNavigate } from 'react-router-dom'

export function IneligibleStep() {
  const navigate = useNavigate()
  const { missionsUrl } = useMissionsUrl()

  return (
    <div className="m-auto flex max-w-[800px] flex-col items-center gap-4 mt-4">
      <div className="flex w-full flex-col items-center gap-6 rounded-2xl border border-solid border-gray-100 px-10 py-12 text-center">
        <div className="text-gray-80 flex size-20 items-center justify-center rounded-full bg-gray-100">
          <MicOff className="size-10" />
        </div>

        <div className="flex flex-col items-center gap-2">
          <div className="text-h5 text-gray-70">
            <Trans>Conversation is not available</Trans>
          </div>
          <div className="text-body-2 text-gray-80 max-w-[460px]">
            <Trans>It looks like you&apos;ve used all your available attempts for this mission.</Trans>
          </div>
        </div>

        <div className="flex flex-col items-center gap-3 pt-2">
          <div className="text-body-3 text-gray-80">
            <Trans>Feel free to explore another mission.</Trans>
          </div>
          <Button variant="default" size="small" onClick={() => navigate(missionsUrl)} className="gap-2">
            <Trans>Browse missions</Trans>
          </Button>
        </div>
      </div>
    </div>
  )
}
